import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';
import Article from './ui/Article.js'
import Section from './ui/Section.js'
import Code from './ui/Code.js'
import ReactMarkdown from 'react-markdown';

function fixFieldFullType(str) {
    // When a field type belongs to a different package, we get this
    // happyco.inspect.type.v1..happyco.type.v1.FloatArray
    var parts = str.split("..");
    return parts[parts.length - 1];
}

class Message extends Component {

    render() {
        const overview = this.props.descriptor.overview || this.props.descriptor.description;

        const fields = this.props.descriptor.fields.length ? (
            <table class="table table-bordered">
                <tbody>
                    { this.props.descriptor.fields
                        .filter((field) => { return !field.hidden; })
                        .map((field) => (
                            <tr>
                                <td>
                                    <div className="mb-1"><strong>{field.name}</strong></div>
                                    <div className="mb-1">
                                        <Link to={fixFieldFullType(field.fullType)}>{field.type}</Link>
                                        {field.label && <span className="text-muted small"> ({field.label})</span>}
                                    </div>
                                </td>
                                <td>
                                    <div>{field.description}</div>
                                </td>
                            </tr>
                        )) }
                </tbody>
            </table>
        ) : (
            <div>This message doesn't contain any fields.</div>
        )

        return (
            <Article kind="Message" title={this.props.descriptor.longName} subtitle={this.props.descriptor.summary}>
                {overview &&
                    <Section title="Overview">
                        <ReactMarkdown source={overview} />
                    </Section>
                }
                <Section title="Fully Qualified Name">
                    <Code>{this.props.descriptor.fullName}</Code>
                </Section>
                <Section title="Fields">
                    { fields }
                </Section>
                {this.props.descriptor.exampleCode &&
                    <Section title="Example Code">
                        <h3>JavaScript</h3>
                        <Code>{this.props.descriptor.exampleCode.javaScript}</Code>
                    </Section>
                }
            </Article>
        );
    }
}

export default Message;



// WEBPACK FOOTER //
// ./src/reference/Message.js